import type { ReviewedLibraryIdentity } from './library-identity-types';
import { SQUAT_ADDITIONS, squatTeachingId } from '../course-materials/squat-materials-20261011';

export const LIBRARY_SQUATS_20261011: ReviewedLibraryIdentity[] = SQUAT_ADDITIONS.map(item => ({
  id: item.libraryId, name: item.name, group: 'legs', subCategory: 'quadriceps', equipment: 'barbell',
  pattern: item.pattern, legacyIds: [squatTeachingId(item.key)], sourceId: squatTeachingId(item.key),
  targetMuscles: ['股四头肌', '臀大肌'],
  evidence: '用户深蹲.zip分类说明与本地视频画面核对；脚尖朝向、持杠位置和加垫变式独立保留',
}));
